export default __webpack_public_path__ + "static/media/ipadNew.59adb4d5.png";